import { css } from '@emotion/css';
import c from 'classnames';

const minHeight48 = css`
  min-height: 4.8rem;

  .MuiAlert-action {
    padding-top: 0;
  }

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const SNACKBAR_CONTAINER_CLASSES = {
  error: c('bg-bg-error py-12 pe-20 ps-16', minHeight48),
  primary: c('bg-bg-highlight py-12 pe-20 ps-16', minHeight48),
};

const iconColorStyles = (token: string) => css`
  &.MuiAlert-icon {
    color: var(--${token});
  }
`;

export const ICON_CLASSES = {
  error: iconColorStyles('icon-error'),
  info: iconColorStyles('icon-placeholder'),
  success: iconColorStyles('icon-success-light'),
};

/**
 * Snackbar stuck in open state and blocks ui
 * ref: https://github.com/mui/material-ui/issues/32286
 */
export const TRANSITION_PROPS = {
  onEnter: (node: HTMLElement) => node.classList.remove('snackbar-exiting'),
  onExit: (node: HTMLElement) => node.classList.remove('snackbar-exiting'),
  onExiting: (node: HTMLElement) => node.classList.add('snackbar-exiting'),
};

export const snackbarExitingStyles = css`
  &.MuiSnackbar-root:has(> div[class*='snackbar-exiting']) {
    pointer-events: none;
  }
`;
